import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { addCommas } from "../../utils/str"

class OrganizationSeo extends React.Component {
  render() {
    const { item, companyName, corporationId } = this.props
    // JSON+LDの設定
    const jsonLd = {
      "@context": "https://schema.org/",
      "@type": "Organization",
      "name": companyName,
      "address": [{
        "@type": "PostalAddress",
        "addressCountry": "日本",
        "addressLocality": item.city_name,
        "addressRegion": item.prefecture_name,
        "streetAddress": item.street_number
      }],
      "sameAs": [
        `https://keyman-db.smart-letter.com/corporations/${corporationId}`
      ]
    }

    // 企業情報
    if (item && item.shikiho_feature) {
      jsonLd.description = item.shikiho_feature
    }

    // 電話番号
    if (item && item.shikiho_tel) {
      jsonLd.telephone = item.shikiho_tel
    }

    // 企業ホームページ
    if (item && item.shikiho_site_url) {
      jsonLd.url = item.shikiho_site_url
    }

    // 企業ロゴ
    if (item && item.logo_path) {
      jsonLd.image = item.logo_path
    }

    // 従業員数
    if (item && item.number_of_employees) {
      if (
        item.number_of_employees === 0 ||
        item.number_of_employees === "0" ||
        item.number_of_employees === "-" ||
        item.number_of_employees === ""
      ) {
      } else {
        jsonLd.numberOfEmployees = addCommas(item.number_of_employees) + "人"
      }
    }

    return (
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
    )
  }
}

OrganizationSeo.propTypes = {
  item: PropTypes.object,
  companyName: PropTypes.string,
  corporationId: PropTypes.number,
}

export default OrganizationSeo